import { replaceUrlPlaceholders } from "react-utils";
import axiosCoralie from "../axios-setup";
import { addQueryParams } from "../utils/urlUtils";

const CONF = window?.confPub;
const PERSONNE_ROUTES = CONF?.ROUTES?.PERSONNE
const CONTRAT_ROUTES = CONF?.ROUTES?.CONTRAT
const INFINITE_ROUTES = CONF?.ROUTES?.INFINITE

export const getRecherchePersonneByNomPRenomDateNaissance = async (nom, prenom, dateNaissance, rechercheEtendue) => {

    const queryParams = new URLSearchParams({
        nom: nom,
        prenom: prenom,
        ...(dateNaissance && { dateNaissance: dateNaissance }),
        rechercheEtendue: rechercheEtendue,
    });

    console.log("rechercheEtendue")
    console.log(rechercheEtendue)

    console.log("getRecherchePersonneByNomPRenomDateNaissance req: ", queryParams.toString())

    try {
        const resp = await axiosCoralie.get(`${PERSONNE_ROUTES?.RECHERCHE_PERSONNE_BY_NOM_PRENOM_DATE_NAISSANCE}?${queryParams.toString()}`)

        console.log("resp", resp)

        return resp

    } catch (err) {
        throw err;
    }
}

export const getRecherchePersonneByNumContrat = async (numContrat) => {

    const RECHERCHE_PERSONNE_BY_NUMERO_CONTRAT = PERSONNE_ROUTES?.RECHERCHE_PERSONNE_BY_NUMERO_CONTRAT
    const urlWithNumContrat = replaceUrlPlaceholders(RECHERCHE_PERSONNE_BY_NUMERO_CONTRAT, { numContrat: numContrat })

    try {
        const resp = await axiosCoralie.get(urlWithNumContrat)

        console.log("getRecherchePersonneByNumContrat : ", resp)

        return resp

    } catch (err) {
        throw err;
    }
}

export const getRechercheDetailContrat = async (numContrat) => {

    const RECHERCHE_DETAIL_CONTRAT = PERSONNE_ROUTES?.RECHERCHE_DETAIL_CONTRAT
    const urlWithNumContrat = replaceUrlPlaceholders(RECHERCHE_DETAIL_CONTRAT, { numContrat: numContrat })

    try {
        const resp = await axiosCoralie.get(urlWithNumContrat)

        console.log("getRechercheDetailContrat : ", resp)

        return resp?.data

    } catch (err) {
        throw err;
    }
}

export const getRecherchePersonneByNumAgent = async (numAgent) => {

    const RECHERCHE_PERSONNE_BY_NUMERO_AGENT = PERSONNE_ROUTES?.RECHERCHE_PERSONNE_BY_NUMERO_AGENT
    const urlWithNumAgent = replaceUrlPlaceholders(RECHERCHE_PERSONNE_BY_NUMERO_AGENT, { numAgent: numAgent })

    try {
        const resp = await axiosCoralie.get(urlWithNumAgent)

        console.log("getRecherchePersonneByNumAgent : ", resp)

        return resp

    } catch (err) {
        throw err;
    }
}

export const getRechercheDetailPersonne = async (idGrc) => {

    const RECHERCHE_DETAIL_PERSONNE = PERSONNE_ROUTES?.RECHERCHE_DETAIL_PERSONNE
    const urlWithIdGrc = replaceUrlPlaceholders(RECHERCHE_DETAIL_PERSONNE, { idGrc: idGrc })

    try {
        const resp = await axiosCoralie.get(urlWithIdGrc)

        console.log("getRechercheDetailPersonne : ", resp)

        if (resp?.data) {

            return resp?.data
        } else {
            throw "Pas de détails personne disponible";
        }

        // return resp?.data?.[0]

    } catch (err) {
        throw err;
    }
}

export const getRechercheProspect = async (nom, prenom, dateNaissance, rechercheEtendue) => {

    console.log("rechercheEtendue")
    console.log(rechercheEtendue)
    const queryParams = new URLSearchParams({
        nom: nom,
        prenom: prenom,
        ...(dateNaissance && { dateNaissance: dateNaissance }),
        rechercheEtendue: rechercheEtendue,
    });

    try {
        const resp = await axiosCoralie.get(`${PERSONNE_ROUTES?.RECHERCHE_PROSPECT}?${queryParams.toString()}`)

        console.log("getRechercheProspect : ", resp)

        return resp

    } catch (err) {
        throw err;
    }
}

/**
 * Récupère les infos Sécurité sociale
 * @param numContrat
 * @param numPersonne
 * @param dateAdhesionContrat
 * @param rangAssure
 * @returns {Promise<any>}
 */
export const rechercheInfosRegimeObligatoire = async (numContrat, numPersonne, dateAdhesionContrat, rangAssure) => {

    const queryParams = addQueryParams({
        numContrat, numPersonne, dateAdhesionContrat, rangAssure
    })
    const RECHERCHE_INFOS_COMP_1 = INFINITE_ROUTES?.RECHERCHE_INFOS_COMP_1 + queryParams

    try {
        const resp = await axiosCoralie.get(RECHERCHE_INFOS_COMP_1)

        console.log("resp")
        console.log(resp)

        return resp?.data

    } catch (err) {
        throw err;
    }
}

/**
 * Récupère les infos bancaires
 * @param numeroContrat
 * @param dateAdhesionContrat
 * @returns {Promise<any>}
 */
export const rechercheInfoComplementaires2 = async (numeroContrat, dateAdhesionContrat) => {

    const RECHERCHE_INFOS_COMP_2 = INFINITE_ROUTES?.RECHERCHE_INFOS_COMP_2;
    const urlRechercheInfoComp2 = replaceUrlPlaceholders(RECHERCHE_INFOS_COMP_2, { numeroContrat: numeroContrat });

    try {
        const resp = await axiosCoralie.get(urlRechercheInfoComp2 + "?dateAdhesionContrat=" + dateAdhesionContrat)

        return resp?.data

    } catch (err) {
        throw err;
    }
}